/**
 * Single source of truth for the campaign response options shown in the
 * response dropdown on each asset row.
 *
 * To add, remove, or reorder an option, edit this array only — the
 * {@link CampaignResponseValue} type and every consumer derive from it
 * automatically. `labelKey`/`evidenceLabelKey` are keys into
 * `campaigns.responseOptions` in `uistrings.json`.
 */
export const RESPONSE_OPTION_CONFIG = [
  { value: "current-device", labelKey: "currentDevice", descriptionKey: "currentDeviceDescription" },
  { value: "testing-device", labelKey: "testingDevice", descriptionKey: "testingDeviceDescription" },
  {
    value: "already-returned",
    labelKey: "alreadyReturned",
    descriptionKey: "alreadyReturnedDescription",
    requiresEvidence: true,
    evidenceLabelKey: "alreadyReturnedEvidenceLabel",
  },
  { value: "want-to-return", labelKey: "wantToReturn", descriptionKey: "wantToReturnDescription" },
  { value: "dont-have", labelKey: "dontHave", descriptionKey: "dontHaveDescription" },
  { value: "cico-laptop", labelKey: "cicoLaptop", descriptionKey: "cicoLaptopDescription" },
] as const satisfies readonly {
  value: string;
  labelKey: string;
  descriptionKey: string;
  requiresEvidence?: boolean;
  evidenceLabelKey?: string;
}[];

export type CampaignResponseValue = (typeof RESPONSE_OPTION_CONFIG)[number]["value"] | "";
